export const reviews = [
  {
    id: '1',
    roomId: '1',
    author: 'Nguyễn Minh Tuấn',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Vietnamese%20man%20portrait%2C%20friendly%20smile%2C%20professional%20photo%2C%20clean%20background&width=100&height=100&seq=av1&orientation=squarish',
    rating: 5,
    content: 'Phòng rất đẹp và sạch sẽ, chủ nhà nhiệt tình. Wifi nhanh, điều hòa mát. Vị trí thuận tiện, gần chợ và trường học. Mình đã ở được 6 tháng và rất hài lòng!',
    date: '2025-03-15',
    roomName: 'Studio A1',
    images: [
      'https://readdy.ai/api/search-image?query=clean%20modern%20apartment%20room%20photo%20taken%20by%20tenant%2C%20cozy%20interior%2C%20good%20lighting&width=300&height=200&seq=rv1a&orientation=landscape',
    ],
  },
  {
    id: '2',
    roomId: '2',
    author: 'Trần Thị Lan',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Vietnamese%20woman%20portrait%2C%20friendly%20smile%2C%20professional%20photo%2C%20clean%20background&width=100&height=100&seq=av2&orientation=squarish',
    rating: 5,
    content: 'Căn hộ 1 phòng ngủ rộng rãi, thoáng mát. Nội thất mới, đầy đủ tiện nghi. Bảo vệ 24/7 rất an tâm. Giá cả hợp lý so với chất lượng. Sẽ giới thiệu cho bạn bè!',
    date: '2025-03-10',
    roomName: '1 Phòng Ngủ B2',
    images: [],
  },
  {
    id: '3',
    roomId: '3',
    author: 'Lê Văn Hùng',
    avatar: 'https://readdy.ai/api/search-image?query=Vietnamese%20man%20middle%20age%20portrait%2C%20friendly%20expression%2C%20casual%20photo&width=100&height=100&seq=av3&orientation=squarish',
    rating: 5,
    content: 'Phòng Deluxe tầng 7 view rất đẹp! Buổi sáng nhìn ra thành phố thật tuyệt. Phòng sạch, nội thất cao cấp. Chủ nhà hỗ trợ rất nhanh khi có vấn đề.',
    date: '2025-02-28',
    roomName: 'Deluxe C3',
    images: [
      'https://readdy.ai/api/search-image?query=city%20view%20from%20apartment%20window%2C%20beautiful%20urban%20landscape%2C%20morning%20light&width=300&height=200&seq=rv3a&orientation=landscape',
    ],
  },
  {
    id: '4',
    roomId: '1',
    author: 'Phạm Thu Hương',
    avatar: 'https://readdy.ai/api/search-image?query=Vietnamese%20young%20woman%20portrait%2C%20happy%20smile%2C%20casual%20style%20photo&width=100&height=100&seq=av4&orientation=squarish',
    rating: 4,
    content: 'Phòng đẹp, sạch sẽ. Wifi tốt, điều hòa mát. Chỉ có điều thang máy đôi khi hơi chậm nhưng không ảnh hưởng nhiều. Nhìn chung rất hài lòng với lựa chọn này.',
    date: '2025-02-20',
    roomName: 'Studio A1',
    images: [],
  },
  {
    id: '5',
    roomId: '5',
    author: 'Hoàng Đức Nam',
    avatar: 'https://readdy.ai/api/search-image?query=Vietnamese%20businessman%20portrait%2C%20professional%20look%2C%20confident%20smile&width=100&height=100&seq=av5&orientation=squarish',
    rating: 5,
    content: 'Premium penthouse tuyệt vời! View 360 độ nhìn toàn thành phố. Không gian rộng rãi, sang trọng. Xứng đáng với mức giá. Đây là nơi ở lý tưởng cho người muốn tận hưởng cuộc sống.',
    date: '2025-02-15',
    roomName: 'Premium E5',
    images: [
      'https://readdy.ai/api/search-image?query=panoramic%20city%20view%20from%20penthouse%20rooftop%2C%20beautiful%20skyline%2C%20sunset%20colors&width=300&height=200&seq=rv5a&orientation=landscape',
    ],
  },
  {
    id: '6',
    roomId: '4',
    author: 'Vũ Thị Mai',
    avatar: 'https://readdy.ai/api/search-image?query=Vietnamese%20woman%20portrait%2C%20warm%20smile%2C%20natural%20look&width=100&height=100&seq=av6&orientation=squarish',
    rating: 4,
    content: 'Phòng Economy nhưng chất lượng không thua kém. Sạch sẽ, đầy đủ tiện nghi cơ bản. Giá rất hợp lý cho sinh viên. Chủ nhà thân thiện, hỗ trợ nhiệt tình.',
    date: '2025-01-30',
    roomName: 'Economy D4',
    images: [],
  },
  {
    id: '7',
    roomId: '2',
    author: 'Đặng Quốc Bảo',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Vietnamese%20man%20casual%20portrait%2C%20friendly%20look%2C%20outdoor%20background&width=100&height=100&seq=av7&orientation=squarish',
    rating: 5,
    content: 'Ở đây được 1 năm rồi, rất hài lòng! Môi trường sống tốt, hàng xóm thân thiện. Quản lý tòa nhà chuyên nghiệp. Sẽ tiếp tục gia hạn hợp đồng.',
    date: '2025-01-20',
    roomName: '1 Phòng Ngủ B2',
    images: [],
  },
];

export const overallStats = {
  averageRating: 4.8,
  totalReviews: 264,
  ratingBreakdown: {
    5: 78,
    4: 15,
    3: 5,
    2: 1,
    1: 1,
  },
};
